import LazyLoad from '@slickdeals/blueprint-twig/javascript/core/lazyLoad';
import '@slickdeals/blueprint-twig/javascript/patterns/dealContentListModule';
import '@slickdeals/blueprint-twig/javascript/patterns/storeLink';
import '../patterns/sidebarDeals';
import '../patterns/inlineResponse';
import { initPage } from '../utilities/initPage';
new LazyLoad(); // eslint-disable-line no-new
initPage();
